import React from "react";
import "../chiller-van/chiller-van.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBox,
  faStar,
  faTruckMedical,
  faMapLocationDot
} from "@fortawesome/free-solid-svg-icons";

const WhyChooseTruck = () => {

  const features = [
    {
      title: "Safe Packing",
      icon: faBox,
      description: `Chiller Fleet Chiller Van ensures secure packing for all goods. Products are placed
      in cartons on shelves to prevent collapse during transit. Our chiller trucks from
      3, 5, 7, to 10 tons maintain stability and safety. Tail-lift trucks reduce extra
      handling and all cargo is fixed securely to protect the cold chain.`,
    },

    {
      title: "Quality Service",
      icon: faStar,
      description: `Our reefer truck rental and chiller van services in Dubai deliver
      excellence at every step. With more than 2,700 successful deliveries last year,
      we have proven the reliability of our temperature-controlled transport. Many
      businesses now rely on us as their permanent logistics partner.`,
    },

    {
      title: "Clean & Sanitized Vehicles",
      icon: faTruckMedical,
      description: `We prioritize hygiene with sanitized and regularly serviced vehicles.
      Each chiller van, freezer truck, and refrigerated truck is inspected after every
      delivery. Our fleet supervisors ensure spotless interiors and proper temperature
      control for safe cold transport.`,
    },

    {
      title: "UAE Wide Coverage",
      icon: faMapLocationDot,
      description: `Based in Dubai, we serve the entire UAE including Abu Dhabi,
      Sharjah, Ajman, and Ras Al Khaimah. With multiple fleet yards and offices,
      we provide fast and reliable refrigerated transport anywhere in the country.`,
    }
  ];

  return (
    <section className="industries-section py-5">
      <div className="container-fluid container-xl text-center">

        <h2 data-aos="fade-up" data-aos-delay="200">Why Choose Us for Truck Rental Service in UAE</h2>

        <p data-aos="fade-up" data-aos-delay="300">
          We never compromise on quality, delivery time, or product safety.
          Our refrigerated fleet is maintained at peak standards and our
          pricing remains affordable, ensuring businesses get reliable
          temperature-controlled transport whenever they need it.
        </p>

        <div className="row mt-4">

          {features.map((item, index) => (

            <div className="col-md-6 col-lg-3 mb-4" key={index} data-aos="zoom-in" data-aos-delay="200">

              <div className="single-service-card p-3 p-lg-4">

                <div className="d-flex align-items-center justify-content-center">

                  <FontAwesomeIcon
                    icon={item.icon}
                    className="service-icon"
                  />

                  <h3 className="mb-0 ps-3">{item.title}</h3>

                </div>

                <hr />

                <p>{item.description}</p>

                <div className="pt-3 d-flex gap-3 justify-content-center flex-wrap">

                  <a href="tel:+971544792905" className="btn--primary">
                    Call Now
                  </a>

                  <a
                    href="https://wa.me/971544792905"
                    className="btn--primary inverse"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    WhatsApp
                  </a>

                </div>

              </div>

            </div>

          ))}

        </div>

      </div>
    </section>
  );
};

export default WhyChooseTruck;